




















import Vue from 'vue';
export default Vue.extend({
  computed: {
    isDisabled(): boolean {
      return this.readonly && !this.isFocused;
    },
  },
  data() {
    return {
      isFocused: false,
      $_veeValidate: {
        value() {
          return this.value;
        },
        name(): string {
          return (this as any).label || this.name;
        },
      },
    };
  },
  methods: {
    focusArea() {
      (this.$refs.textarea as HTMLTextAreaElement).focus();
    },
  },
  name: 'TextArea',
  props: {
    id: {
      default: '',
      type: String,
    },
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    readonly: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    type: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
});
